import { render } from "./blank-page.vue?vue&type=template&id=7f5ce49a"
import script from "./blank-page.vue?vue&type=script&lang=js"
export * from "./blank-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__